import type { SubmitCallbackArgs } from '@inkeep/cxkit-types';

import { submitSupportTicket } from 'shared/lib/support/submitSupportTicket';

type SupportTicketFormValues = {
  fullname: string;
  email: string;
  subject: string;
  description: string;
  hs_file_upload?: FileList;
  include_transcript?: boolean;
};

export const serializeTranscript = (conversation: SubmitCallbackArgs['conversation']): string => {
  if (!conversation?.messages?.length) {
    return '';
  }

  return conversation.messages
    .filter((msg) => msg.role !== 'system')
    .map((msg) => {
      const role = msg.role === 'user' ? 'User' : 'Truv AI';
      const content = typeof msg.content === 'string' ? msg.content : (msg.content?.map((c) => c.text).join('') ?? '');
      return `[${role}]: ${content}`;
    })
    .join('\n');
};

/** Adapts Inkeep's form callback onto the shared support-ticket submission. */
export const submitHubSpotTicket = async ({ values, conversation }: SubmitCallbackArgs): Promise<void> => {
  const {
    fullname = '',
    email = '',
    subject = '',
    description = '',
    hs_file_upload,
    include_transcript,
  } = values as SupportTicketFormValues;

  await submitSupportTicket({
    fullName: String(fullname),
    email: String(email),
    subject: String(subject),
    description: String(description),
    file: hs_file_upload?.[0],
    transcript: include_transcript ? serializeTranscript(conversation) : undefined,
  });
};
